module.exports = __webpack_public_path__ + "static/media/ticon2.7ddf8664.webp";